module.exports = __webpack_public_path__ + "static/integrify-db3c3a5e8175654f9f5c8c5dbf815ba7.svg";